import OddsTab from './OddsTabHandler';

export default function () {
    const oddsTab = new OddsTab();
    oddsTab.init();
}




// WEBPACK FOOTER //
// ./lib/js/modules/oddsTabHandler/index.js